import React from "react";
import { Container} from "react-bootstrap";
import Particle from "../Particle";
import Techstack from "./Techstack";
import Toolstack from "./Toolstack";
import Languagestack from "./languagestack";

function Skill() {
  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
           <strong className="purple">Language</strong> i Spoke 
        </h1>
        <Languagestack/>


        <h1 className="project-heading">
        My <strong className="purple">skill set </strong>
        </h1>
        <Techstack />

        <h1 className="project-heading">
          <strong className="purple">Additional</strong> Tools
        </h1>
        <Toolstack />
      </Container>
    </Container>
  );
}

export default Skill;
